
/*
 * Copyright (C) 2015 ICOS Group, Newcastle University.  All rights reserved.
 * Contact:  James Alastair McLaughlin <j.a.mclaughlin@ncl.ac.uk>
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *  
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 */

"use strict";

var Identified = require('./Identified');

var util = require('./util')

/**
 * Class to represent an SBOL2 Collection.
 */
class Collection extends Identified
{
    constructor(sbolDocument, uri) {

        super(sbolDocument, uri);

        this._members = []
    }

    /**
     * Add a member to this Collection.
     * @param {string|URI|Identified} [member]
     */
    addMember(member) {
        this._members.push(util.uriOrObject(member));
    }

    /**
     * Retrieve the list of members assigned to this Collection.  There
     * may be URIs present in this list if the member(s) have not yet been
     * resolved.
     *
     * @returns {Identified[]}
     */
    get members() {
        return this._members.slice(0);
    }

    /**
     * Attempt to resolve the members assigned to this Collection by URI.
     */
    link() {
		// Call super link to link members of Top Level (Identified)
		super.link();
		
        this._members = this._sbolDocument.lookupURIs(this._members);
    }
}

module.exports = Collection;





